import React from 'react';
import styles from '@/styles/CardBox.module.scss';
import { PEIImage } from '@/common';

export const CardRow = (props: { record: string; iconImage: string }) => {
  return (
    <div className={`${styles.rowItem} ${styles.rowItemBorder}`}>
      <div className={styles.iconStyle}>
        <PEIImage className={styles.icon} src={props.iconImage} alt='icon' width={5} height={5} />
      </div>
      <p className={styles.innerTextStyle}>{props.record}</p>
    </div>
  );
};
